type NewLineToBrProps = {
  text?: string
};

export const NewLineToBr = (props: NewLineToBrProps) => {
  const lines = props.text?.split('\\n').map(function (line, n) {
    return (n == 0) ? [line] : [<br key={`line-${n}`} />, line];
  });
  return <span>{lines}</span>;
};

export const clamp = (min: number, max: number) => Math.min(Math.max(min + (window.innerWidth - 375) / (1920 - 375) * (max - min), min), max);
